import React, { useContext, useEffect } from 'react'
import { BrowserView, MobileView } from 'react-device-detect'
import FlexView from 'react-flexview/lib'
import { Controller, useForm, useFormContext } from 'react-hook-form'
import {
  SessionContextStore,
  SESSION_ACTIONS,
} from '../../../context/SessionContext'
import {
  EventEmitterService,
  EventKey,
} from '../../../services/EventEmitterService'
import '../UserProfile.css'
import {
  ACTIONS,
  UserProfileContextStore,
} from '../../../context/UserProfileContext'
import { Action } from '../../../models/Action'
import {
  FormControlLabel,
  FormHelperText,
  Radio,
  RadioGroup,
} from '@material-ui/core'
import { COVERAGE_TYPES } from '../../../models/insurance-models/CoverageType'
import { SkyInformationPopover } from '../../Core/Popover/SkyPopover'
import { CFITooltip, PersonalTooltip } from '../../../Constants'
const dayjs = require('dayjs')

export const InsuranceTypeSection = (props) => {
  const context = useContext(UserProfileContextStore)
  const sessionContext = useContext(SessionContextStore)
  const { register, watch, setValue, errors, control, getValues } =
    useFormContext()
  const insuranceType = watch('insurance_type')
  const methods = useForm({ mode: 'onChange' })

  useEffect(() => {
    const id = EventEmitterService.subscribe(
      EventKey.USER_PROFILE_SAVE,
      async () => {
        const valid = await methods.trigger()
        if (valid) {
          context.dispatch(new Action(ACTIONS.SAVE_INSURANCE_TYPE, getValues()))
        }
      }
    )

    return function cleanup() {
      EventEmitterService.unsubscribe(EventKey.USER_PROFILE_SAVE, id)
    }
  }, [])

  useEffect(() => {
    setValue('insurance_type', sessionContext.user.insuranceType)
  }, [sessionContext.user])

  return (
    <React.Fragment>
      <Controller
        register={register}
        control={control}
        name="insurance_type"
        rules={{ required: true }}
        render={(
          { onChange, onBlur, value, name, ref },
          { invalid, isTouched, isDirty }
        ) => (
          <RadioGroup
            onChange={(e) => {
              onChange(e.target.value)
            }}
            value={value}>
            <div>
              <FlexView vAlignContent={'center'} className="margin-top-basic">
                <div className="margin-right-20">
                  <FormControlLabel
                    style={{ marginRight: '0' }}
                    label={'Personal Business and Pleasure'}
                    value={COVERAGE_TYPES.PERSONAL}
                    control={<Radio color="primary" />}
                  />
                  <SkyInformationPopover style={{ fontSize: '0.9rem' }}>
                    <div className="text-small">{PersonalTooltip}</div>
                  </SkyInformationPopover>
                </div>
                <div>
                  <FormControlLabel
                    style={{ marginRight: '0' }}
                    label={
                      'CFI & Personal (Includes Personal Business and Pleasure)'
                    }
                    value={COVERAGE_TYPES.CFI}
                    control={<Radio color="primary" />}
                  />
                  <SkyInformationPopover style={{ fontSize: '0.9rem' }}>
                    <div className="text-small">{CFITooltip}</div>
                  </SkyInformationPopover>
                </div>
              </FlexView>
            </div>
          </RadioGroup>
        )}
      />
      {!!errors.insurance_type && (
        <FormHelperText error={!!errors.insurance_type}>
          Required
        </FormHelperText>
      )}
    </React.Fragment>
  )
}
